import { render } from "./accept_money_in_cashier.vue?vue&type=template&id=1672b93d"
import script from "./accept_money_in_cashier.vue?vue&type=script&lang=js"
export * from "./accept_money_in_cashier.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__